import { html, unsafeCSS, type CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { LibElement } from '../lib-element';
import type { LibSidebarItem } from '../sidebar-item/lib-sidebar-item';
import css from './lib-sidebar.css';

/** Icon navigation strip with shared item defaults. */
@customElement('lib-sidebar')
export class LibSidebar extends LibElement {
  static override readonly styles: CSSResultGroup = [LibElement.hostStyles, unsafeCSS(css)];
  @property() alignment = 'left';
  @property({ type: Boolean, attribute: 'hide-labels' }) hideLabels = false;

  protected override updated() {
    this.querySelectorAll<LibSidebarItem>('lib-sidebar-item').forEach(item => item.requestUpdate());
  }

  override render() {
    return html`<div class="sidebar-container"><slot></slot></div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap { 'lib-sidebar': LibSidebar; }
}
